import React from 'react';
import classNames from 'classnames';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';
import StartTime from 'main/components/show/cuesheet/startTime';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const SimpleStartTimeCell = (props) => {
  const { item, userId, isSelected } = props;

  const wrapperClasses = classNames(
    'cs-simple-cell-wrapper',
    HighlightCellHelper.getPersonalHighlightClass(item, userId),
  );

  const cellClasses = classNames('cs-cell cs-data-cell', {
    'cs-cell-selected': isSelected,
  });

  return (
    <div
      className={wrapperClasses}
      style={HighlightCellHelper.getPersonalHighlightStyle(item, userId)}
    >
      <div
        style={HighlightCellHelper.getGlobalHighlightStyle(item)}
        className={cellClasses}
      >
        <StartTime
          simple
          isSelected={isSelected}
          startOn={item.get('startOn')}
          startTimeBackwardAdjusted={item.get('startTimeBackwardAdjusted')}
          displayStartTimeClock={item.get('displayStartTimeClock')}
          startOnInReverse={item.get('startOnInReverse')}
          {...props}
        />
      </div>
    </div>
  );
};

export default SimpleStartTimeCell;
